import { IComponent } from "./component";
import { ISaveTag } from "./tags";
import { IProgramTag } from "./program_tags";

export enum ProgramMethod {
    DEFAULT = "default",
    AND = "AND",
    OR = "or",
    NOT = "not",
    NAND = "nand",
    NOR = "nor",
    XOR = "xor",
};

export interface IProgram {
    id?: number;
    category_id?: number;
    active: boolean;
    name: string;
    description: string;
    method: ProgramMethod;
    gov_url: string;
    province_id: number | null;
    components: IComponent[];
    program_tags: IProgramTag[];
}

export interface ISaveProgram {
    id?: number;
    category_id: number;
    active: boolean;
    name: string;
    description: string;
    method: ProgramMethod;
    gov_url: string;
    province_id: number | null;
    tags: ISaveTag[];
};